import { merge } from "theme-ui"
import baseTheme from "@lekoarts/gatsby-theme-minimal-blog/src/gatsby-plugin-theme-ui"

const colors = {
  text: `#172033`,
  background: `#fbfcff`,
  primary: `#2f5f9f`,
  secondary: `#5f6b7a`,
  accent: `#8b3f2f`,
  heading: `#101827`,
  divide: `#d9e0ea`,
  muted: `#eef3f8`,
  toggleIcon: `#5f6b7a`,
  pillBackground: `#fff`,
}

const darkColors = {
  text: `#ece8df`,
  background: `#141414`,
  primary: `#8ab4e6`,
  secondary: `#b8b2a8`,
  accent: `#e0a06c`,
  heading: `#fff7e8`,
  divide: `#36332d`,
  muted: `#211f1c`,
  toggleIcon: `#e0a06c`,
  pillBackground: `#1c1b18`,
}

const theme = merge(baseTheme, {
  config: {
    initialColorModeName: `dark`,
    useColorSchemeMediaQuery: false,
  },
  colors: {
    ...colors,
    modes: {
      dark: darkColors,
    },
  },
  fonts: {
    body: `Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
    heading: `Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
  },
  styles: {
    root: {
      color: `text`,
      backgroundColor: `background`,
      letterSpacing: 0,
      a: {
        color: `primary`,
        textDecorationThickness: `1px`,
        textUnderlineOffset: `3px`,
      },
    },
    p: {
      letterSpacing: 0,
      lineHeight: 1.65,
    },
    h1: {
      letterSpacing: 0,
    },
    h2: {
      letterSpacing: 0,
    },
    h3: {
      letterSpacing: 0,
    },
    img: {
      maxWidth: `100%`,
    },
  },
  layout: {
    container: {
      maxWidth: `1080px`,
      px: [3, 4],
      py: [3, 3],
    },
  },
  text: {
    sectionLabel: {
      color: `secondary`,
      fontSize: [0, 1],
      fontWeight: 800,
      letterSpacing: `0.08em`,
      lineHeight: 1.2,
      m: 0,
      textTransform: `uppercase`,
    },
  },
  links: {
    pill: {
      color: `primary`,
      textDecoration: `none`,
      fontWeight: 700,
      border: `1px solid`,
      borderColor: `divide`,
      borderRadius: `999px`,
      px: 3,
      py: 1,
      backgroundColor: `pillBackground`,
      fontSize: 1,
      ":hover": {
        borderColor: `primary`,
      },
    },
    secondary: {
      color: `secondary`,
      textDecoration: `none`,
      ":hover": {
        color: `primary`,
      },
    },
  },
})

export default theme
